import { Avatar, Divider, List, Skeleton } from "antd";
import { useEffect, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import styles from "../styles/SettingNotification.module.css";

const EmployeeList = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const loadMoreData = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        fetch(`https://660d2bd96ddfa2943b33731c.mockapi.io/api/users/?page=${page}&limit=10`)
            .then(res => res.json())
            .then(res => {
                const results = Array.isArray(res) ? res : [];
                setData([...data, ...results]);
                setLoading(false);
                setPage(page + 1);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        loadMoreData();
    }, []);

    return (
        <div
            id="scrollableDiv"
            style={{
                height: 350,
                overflow: 'auto',
                padding: '0 16px',
            }}
        >

            <InfiniteScroll
                dataLength={data.length}
                next={loadMoreData}
                hasMore={data.length < 50}
                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                // endMessage={<Divider plain>It is all, nothing more 🤐</Divider>}
                scrollableTarget="scrollableDiv"
            >
                <List
                    dataSource={data}
                    renderItem={item => (
                        <List.Item key={item.email}>
                            <List.Item.Meta
                                avatar={<Avatar src={item.avatar} size={"large"} />}
                                title={<span style={{ color: "#42526D" }} >{item.name}</span>}
                                description={<span style={{ color: "#42526D" }}>{item.email}</span>}
                            />
                        </List.Item>
                    )}
                    className={styles.listCustom}
                />
            </InfiniteScroll>

        </div>
    )
}

export default EmployeeList;